import { motion } from 'framer-motion';
import { PageTransition, FadeIn, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { Phone } from 'lucide-react';

const teamMembers = [
  {
    name: 'Priyanka Jayaprakash',
    role: 'Training & Development Lead',
    phone: '+91 72040 76681'
  },
  {
    name: 'Anshul Khandelwal',
    role: 'DGM, Visual Merchandising & Training',
    phone: '+91 75079 88702'
  },
  {
    name: 'Rohitkant Prasad',
    role: 'Brand Head',
    phone: '+91 90082 32233'
  }
];

const ProfileCard = ({ member }) => (
  <motion.div
    className="bg-white border border-[rgba(26,26,26,0.1)] p-10 text-center group h-full flex flex-col"
    whileHover={{ y: -8, borderColor: '#1A1A1A' }}
    transition={{ duration: 0.4 }}
  >
    {/* Avatar Circle */}
    <div className="w-24 h-24 mx-auto mb-6 border-2 border-[rgba(26,26,26,0.1)] rounded-full flex items-center justify-center bg-[#F8F6F2] group-hover:border-[#D32F2F] transition-colors duration-500 flex-shrink-0">
      <span className="text-3xl font-light text-[#1A1A1A]">
        {member.name.split(' ').map(n => n[0]).join('')}
      </span>
    </div>

    {/* Name */}
    <h3 className="text-lg font-semibold tracking-wide text-[#1A1A1A] mb-2">
      {member.name}
    </h3>

    {/* Role - Fixed height container */}
    <p className="text-xs uppercase tracking-[0.1em] text-[#1A1A1A]/60 mb-6 min-h-[32px] flex items-center justify-center">
      {member.role}
    </p>

    {/* Phone - Pushed to bottom */}
    <div className="mt-auto">
      {member.phone && (
        <div className="flex items-center justify-center gap-2 text-[#1A1A1A]/70 group-hover:text-[#D32F2F] transition-colors duration-300">
          <Phone size={14} />
          <a 
            href={`tel:${member.phone.replace(/\s/g, '')}`}
            className="text-sm tracking-wide hover:underline"
            data-testid={`phone-${member.name.split(' ')[0].toLowerCase()}`}
          >
            {member.phone}
          </a>
        </div>
      )}
    </div>
  </motion.div>
);

const WhoPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] flex items-center justify-center py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/navigation" label="Back" />

      <div className="max-w-5xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Team
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A] mb-4">
            Who
          </h1>
          <p className="text-sm text-[#1A1A1A]/60 max-w-md mx-auto">
            Your dedicated training and development contacts at The Bear House
          </p>
        </motion.div>

        {/* 3-Column Grid with Equal Cards */}
        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
          {teamMembers.map((member, index) => (
            <StaggerItem key={index} className="h-full">
              <ProfileCard member={member} />
            </StaggerItem>
          ))}
        </StaggerContainer>

        <FadeIn delay={0.6}>
          <div className="text-center mt-16">
            <p className="text-xs uppercase tracking-[0.15em] text-[#1A1A1A]/40">
              For any training queries or support
            </p>
          </div>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default WhoPage;
